import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Select,
  Checkbox,
  SimpleGrid,
} from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { SIMPLE_TYPES } from '../data/qrRegistry';

const QrAdvancedFields = observer(({ store }) => {
  const type = store.qrType;
  if (!type || SIMPLE_TYPES.includes(type.id)) return null;

  const renderField = (field) => {
    const value = store.formData[field.id] ?? field.default ?? '';
    const setValue = (v) => store.setFormData(field.id, v);

    switch (field.type) {
      case 'url':
      case 'email':
      case 'tel':
      case 'text':
        return (
          <Input
            type={field.type}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={field.placeholder}
            size="sm"
            borderRadius="lg"
          />
        );
      case 'number':
        return (
          <Input
            type="number"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={field.placeholder}
            size="sm"
            borderRadius="lg"
          />
        );
      case 'textarea':
        return (
          <Textarea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={field.placeholder}
            size="sm"
            borderRadius="lg"
            rows={2}
          />
        );
      case 'select':
        return (
          <Select value={value} onChange={(e) => setValue(e.target.value)} size="sm" borderRadius="lg">
            {(field.options || []).map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </Select>
        );
      case 'checkbox':
        return (
          <Checkbox isChecked={!!value} onChange={(e) => setValue(e.target.checked)} colorScheme="blue" size="sm">
            {field.label}
          </Checkbox>
        );
      default:
        return (
          <Input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={field.placeholder}
            size="sm"
            borderRadius="lg"
          />
        );
    }
  };

  return (
    <Box mt={3} p={3} borderRadius="lg" bg="blackAlpha.50" _dark={{ bg: 'whiteAlpha.50' }}>
      <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={3}>
        {type.fields
          .filter((f) => f.type !== 'checkbox')
          .map((field) => (
            <FormControl key={field.id} size="sm">
              <FormLabel fontSize="xs" mb={0.5}>
                {field.label}
                {field.required && (
                  <Box as="span" color="red.500" ml={0.5}>
                    *
                  </Box>
                )}
              </FormLabel>
              {renderField(field)}
            </FormControl>
          ))}
        {type.fields
          .filter((f) => f.type === 'checkbox')
          .map((field) => (
            <FormControl key={field.id} gridColumn={{ sm: '1 / -1' }}>
              {renderField(field)}
            </FormControl>
          ))}
      </SimpleGrid>
    </Box>
  );
});

export default QrAdvancedFields;
